import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import { StepMap, steps } from '../../constants';

/*******************************************************************************
 * Address Step Routing
 */
export const addressGraph: Beacon<StepMap> = {
	[steps.Address]: [steps.SystemAge],
};

export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	return steps.SystemAge as StepMap;
};
